import laundriesService from "api/laundriesService";
import { AxiosError } from "axios";
import { useUI } from "providers/UIProvider";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { IApproveRejectLaundryUpdatesBody } from "types/laundry";

const useApproveRejectLaundryUpdates = () => {
  const { T } = useUI()
  return useMutation(async (data: IApproveRejectLaundryUpdatesBody) => {
      const res = await laundriesService.approveRejectLaundryUpdates(data)

      return res.data  
  }, {
    onError: (err: AxiosError<any>) => {
      toast.error(T(`${err.response?.data.MessageId}` || T("general.error")))
    }
  }) 
}

export default useApproveRejectLaundryUpdates